import React, { useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddFrontOffice = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    phone_no: '',
    mobile_no: '',
    allowed_to_edit: false,
    status: true
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (formData.password !== formData.password_confirmation) {
        toast.error('Password and confirmation do not match');
        return;
      }

      const response = await axios.post(
        'https://bmrbackend.dynastymaker.com/api/register/front-office',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      toast.success('Front office user created successfully!');
      setFormData({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone_no: '',
        mobile_no: '',
        allowed_to_edit: false,
        status: true
      });

    } catch (error) {
      console.error('Error creating front office user:', error);
      
      let errorMessage = 'Failed to create front office user';
      if (error.response) {
        if (error.response.data.errors) {
          errorMessage = Object.values(error.response.data.errors).flat().join('\n');
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4">
      <div className='d-flex align-items-center justify-content-center'>
        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
          Front Office Information
        </div>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="card mb-4 shadow-sm">
          <div className="card-body row">
            <div className="mb-3 col-md-6 col-12">
              <label>Name *</label>
              <input 
                type="text" 
                className="form-control" 
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="col-md-6 col-12 mb-3">
              <label>Phone No</label>
              <input 
                type="text" 
                className="form-control" 
                name="phone_no"
                value={formData.phone_no}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6 col-12 mb-3">
              <label>Mobile No *</label>
              <input 
                type="text" 
                className="form-control" 
                name="mobile_no"
                value={formData.mobile_no}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="col-md-6 col-12 d-flex align-items-center mb-3">
              <div className='bg-light p-3 mt-4 w-100 rounded-3'>
                <input 
                  type="checkbox" 
                  name="allowed_to_edit"
                  checked={formData.allowed_to_edit}
                  onChange={handleInputChange}
                />
                <label className='mx-2'>Allow to Edit Leads</label>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex align-items-center mt-3 justify-content-center'>
          <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
            Login Details
          </div>
        </div>

        <div className="card shadow-sm">
          <div className="card-body row">
            <div className="col-md-12 col-12 mb-3">
              <label>Email *</label>
              <input 
                type="email" 
                className="form-control" 
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="col-md-12 col-12 mb-3">
              <label>Password *</label>
              <div className="input-group">
                <div className="input-group-append">
                  <button
                    className="btn btn-lg p-3 borderingbutton btn-outline-primary"
                    type="button"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
                
              </div>
            </div>

            <div className="col-md-12 col-12 mb-3">
              <label>Confirm Password *</label>
              <div className="input-group">
                <div className="input-group-append">
                  <button
                    className="btn btn-lg p-3 borderingbutton btn-outline-primary"
                    type="button"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control"
                  name="password_confirmation"
                  value={formData.password_confirmation}
                  onChange={handleInputChange}
                  required
                />
                
              </div>
            </div>

            <div className="d-flex gap-2 pt-3 pb-3">
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </div>

            <div className="mt-3">
              <Link to={'/super-admin/front-office/view'} type="button" className="btn bg-light buttonadd">
                <IoArrowUndoSharp size={20} /> Back
              </Link>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddFrontOffice;